// core
import React, { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';

// data
import type { institutionLoginsTypes } from 'app-components/flux/institution-logins';
import type { InstitutionGrouping } from 'data/fundingAccounts/selectors';

// mui
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import AccountStatusChipList from 'components/Chips/AccountStatusChipList';
import Dump from 'components/Dump';
import InstitutionIcon from 'components/InstitutionIcon';
import QPanelButton from 'components/QPanelButton';

const useStyles = makeStyles()(() => ({
  panelClass: {
    padding: 8,
    paddingLeft: 16,
  },
}));

type TransferInstitutionRowProps = {
  index: number;
  handleContinue: (institutionGroup: any) => void;
  institutionGroup: InstitutionGrouping;
  institutionLogin: institutionLoginsTypes.InstitutionLogin | null;
};

const TransferInstitutionRow = ({
  index,
  handleContinue,
  institutionGroup,
  institutionLogin,
}: TransferInstitutionRowProps) => {
  const { classes } = useStyles();

  const { institution, eligible, enabled } = institutionGroup;

  const aggStatus = institutionLogin?.aggregators?.first()?.aggStatus;

  const accountStatus = useMemo(
    () => ({
      error: {
        showChip: aggStatus !== 'OK' && aggStatus != null,
      },
    }),
    [aggStatus],
  );

  let subtitle = '';
  if (eligible?.length && enabled?.length) {
    subtitle =
      `${eligible.length} account${eligible.length === 1 ? '' : 's'} eligible` +
      ` | ${enabled.length} enabled for transfers`;
  } else if (enabled?.length) {
    subtitle = `${enabled.length} account${enabled.length === 1 ? '' : 's'} enabled for transfers`;
  } else {
    subtitle = `${eligible?.length} eligible account${eligible?.length === 1 ? '' : 's'}`;
  }

  return (
    <QPanelButton
      centerText
      className={classes.panelClass}
      id={`institution-${index}`}
      title={institution.get('name')}
      subtitle={subtitle} // {`${eligible?.length} eligible account${eligible?.length === 1 ? '' : 's'}`}
      onClick={() => {
        handleContinue(institutionGroup);
      }}
      startIcon={
        <Box minWidth={64}>
          <Dump obj={institutionGroup} id='institution group' />
          <InstitutionIcon institution={institution} sizePixels={58} />
        </Box>
      }
      arrow={
        <Box display='flex' flexDirection='row'>
          <AccountStatusChipList accountStatus={accountStatus} />
          <IconButton size='large'>
            <ArrowForwardIosIcon fontSize='small' />
          </IconButton>
        </Box>
      }
    />
  );
};

TransferInstitutionRow.displayName = 'TransferInstitutionRow';

export default TransferInstitutionRow;
